import { Link } from "react-router";
import { Button } from "@dg/ui";

export function UnavailablePage() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 text-center">
      <h1 className="text-6xl font-bold text-muted-foreground">502</h1>
      <p className="text-xl font-semibold">
        This app is temporarily unavailable.
      </p>
      <Button asChild variant="outline">
        <Link to="/">Back to dashboard</Link>
      </Button>
    </div>
  );
}
